import {
  SHOP_OPENED_MODE_ADHOC_CLOSED,
  SHOP_OPENED_MODE_DEFAULT,
} from '@chama/utils/constants/status';
import Dealer from '@app/models/Dealer';
import track from '../util/analytics-handler';

export const FETCH_DEALER_DATA = 'FETCH_DEALER_DATA';
export const UPDATE_DEALER_DATA = 'UPDATE_DEALER_DATA';
export const UPDATE_SEVERAL_DEALERS = 'UPDATE_SEVERAL_DEALERS';
export const DEALER_LOADING = 'DEALER_LOADING';
export const ADD_FILTER = 'ADD_FILTER';
export const GET_NEARBY_DEALERS = 'GET_NEARBY_DEALERS';
export const REMOVE_FILTER = 'REMOVE_FILTER';
export const ADD_DEALER_DATA = 'ADD_DEALER_DATA';

export const updateDealerData = (dealerId, updatedData) => (dispatch, getState, { api }) => {
  dispatch({ type: DEALER_LOADING });

  return api.updateDealerData(dealerId, updatedData).then(onUserDataFulfill);

  function onUserDataFulfill(updatedDealer) {
    dispatch({
      type: UPDATE_DEALER_DATA,
      updatedDealer: new Dealer(updatedDealer),
    });
  }
};

export const adHocCloseShop = dealerId => (dispatch, getState, { api }) => {
  const updatedData = {
    isOpenedMode: SHOP_OPENED_MODE_ADHOC_CLOSED,
  };

  dispatch({ type: DEALER_LOADING });

  return api.updateDealerData(dealerId, updatedData).then(onUserDataFulfill);

  function onUserDataFulfill(updatedDealer) {
    return dispatch({
      type: UPDATE_DEALER_DATA,
      updatedDealer,
    });
  }
};

export const reopenShop = dealerId => (dispatch, getState, { api }) => {
  const updatedData = {
    isOpenedMode: SHOP_OPENED_MODE_DEFAULT,
  };

  dispatch({ type: DEALER_LOADING });

  return api.updateDealerData(dealerId, updatedData).then(onUserDataFulfill);

  function onUserDataFulfill(updatedDealer) {
    return dispatch({
      type: UPDATE_DEALER_DATA,
      updatedDealer,
    });
  }
};

export const toggleFilter = number => {
  return (dispatch, getState) => {
    const {
      dealer: { filters },
      user: { username, account },
    } = getState();

    const indexOfFilter = filters.indexOf(number);
    const isSelected = indexOfFilter === -1;

    // Bucket start from 0. For better reading, adding + 1
    const bucketNumber = number + 1;

    track('Clicked Bucket Filter', {
      location: 'OrderHandling',
      type: 'button',
      bucketNumber,
      isSelected,
      username,
      userId: `${username}@${account}`,
    });

    if (!isSelected) {
      // Remove
      dispatch({
        type: REMOVE_FILTER,
        indexOfFilter,
      });
    } else {
      // Add
      dispatch({
        type: ADD_FILTER,
        number,
      });
    }
  };
};

export const getNearbyDealers = (lat, lon) => {
  return (dispatch, getState, { api }) => {
    return api.getNearbyDealers(lat, lon).then(dealers =>
      dispatch({
        type: GET_NEARBY_DEALERS,
        lat,
        lon,
        dealers,
      }),
    );
  };
};

const dealerData = dealers => ({
  type: FETCH_DEALER_DATA,
  dealers,
});

const addDealerToDealersData = dealer => ({
  type: ADD_DEALER_DATA,
  dealer,
});

const dealerDataUpdate = dealer => ({
  type: UPDATE_DEALER_DATA,
  updatedDealer: dealer,
});

/**
 * When application gets loaded, all dealers are fetched.
 *
 * After that, the application will react only when dealer gets added or updated.
 * So we can avoid downloading all the data in every change.
 *
 * Firebase has limitations on 'child_added' event (more here: https://stackoverflow.com/questions/11788902/firebase-child-added-only-get-child-added)
 * Therefore we sort by timestamp to be able to retrieve only the latest one
 */
export const startListeningToDealers = () => (dispatch, getState, { firebaseClient }) => {
  firebaseClient.database.ref('/dealers').once('value', snapshot => {
    const dealers = Object.values(snapshot.val()).map(dealer => new Dealer(dealer));
    dispatch(dealerData(dealers));
  });

  firebaseClient.database
    .ref('/dealers')
    .orderByChild('creationTime')
    .limitToLast(1)
    .on('child_added', snapshot => {
      const dealers = getState().dealer.all;
      const dealer = new Dealer(snapshot.val());
      const dealerKeys = Object.keys(dealers);
      if (dealerKeys.length && !dealerKeys.includes(dealer.id)) {
        dispatch(addDealerToDealersData(dealer));
      }
    });

  firebaseClient.database.ref('/dealers').on('child_changed', snapshot => {
    const dealer = new Dealer(snapshot.val());
    dispatch(dealerDataUpdate(dealer));
  });
};



// WEBPACK FOOTER //
// ./src/actions/dealers.js